import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { userEndpoint } from 'src/app/utils/constants/requestUrl';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  constructor(private http: HttpClient) {}

  usersList(data): Observable<any> {
    return this.http.get(`${environment.userUrl}${userEndpoint.getUserList}`, data);
  }

  activateUser(userID, active): Observable<any> {
    let params = new HttpParams();
    params = params.append('userID', userID);
    params = params.append('active', active);
    return this.http.get(`${environment.userUrl}${userEndpoint.activateUser}`, { params });
  }

  unLockUser(userID, customerID): Observable<any> {
    let params = new HttpParams();
    params = params.append('userID', userID);
    params = params.append('customerID', customerID);
    return this.http.get(`${environment.userUrl}${userEndpoint.unLockUser}`, { params });
  }

  deleteUser(userID, customerID): Observable<any> {
    let params = new HttpParams();
    params = params.append('userID', userID);
    params = params.append('customerID', customerID);
    return this.http.get(`${environment.userUrl}${userEndpoint.deleteUser}`, { params });
  }

  assignRole(userdata): Observable<any> {
    return this.http.post(`${environment.userUrl}${userEndpoint.assignUserRole}`, userdata);
  }
}
